import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { "data-testid": "geist-icon", height: 16, strokeLinejoin: "round", viewBox: "0 0 16 16", width: 16, style: {
  color: "currentcolor"
}, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 8.75,1 H7.25 V7.25 H1.5 V8.75 H7.25 V15 H8.75 V8.75 H14.5 V7.25 H8.75 V1.75 Z", fill: "currentColor" }));
export default SvgPlus;
